import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'
import { statusColorScheme } from '../../style/table/td/index.styled'

export const TableV2Container = styled.div`
	font-size: 1rem;
	width: 100%;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
`
TableV2Container.displayName = 'TableV2Container'

export const TableV2Header = styled.div`
	width: 100%;
	min-height: 4.07em;
	display: grid;
	grid-template-columns: ${(props) => props.columns};
	gap: 1.25em;
	background: ${colorTheme.tableV2.header.background};
	border-bottom: 1px solid ${colorTheme.tableV2.header.border};
	padding: .3em 1.25em .3em 1.88em;
	border-radius: .63em .63em 0 0;

	&.lf-sticky {
		position: sticky;
		top: 0;
		z-index: 3;
	}

	@media screen and (max-width: ${theme.point820}) {
		display: none;
	}
`
TableV2Header.displayName = 'TableV2Header'

export const TableV2HeaderTd = styled.div`
	display: flex;
	align-items: center;

	&.end {
		justify-self: end;
	}

	&.center {
		justify-self: center;
	}

	&.pointer {
		cursor: pointer;
	}
`
TableV2HeaderTd.displayName = 'TableV2HeaderTd'

export const TableV2HeaderTitle = styled.div`
	font-size: 1.13em;
	font-family: ${theme.fontRobotoMedium};
	font-weight: 600;
	color: ${colorTheme.tableV2.header.color};
	width: max-content;

	&.wrap {
		width: min-content;
	}

	&.active {
		color: ${colorTheme.tableV2.header.active};
	}
`
TableV2HeaderTitle.displayName = 'TableV2HeaderTitle'

export const TableV2Body = styled.div`
	width: 100%;
`
TableV2Body.displayName = 'TableV2Body'

export const TableV2Td = styled.div`
	display: flex;
	align-items: flex-start;
	padding: .63em 0;

	&.end {
		justify-self: end;
	}

	&.center {
		justify-content: center;
	}

	@media screen and (max-width: ${theme.point820}) {
		padding: .72em .42em;

		&.tab-col-1-3 {
			grid-column: 1 / 3;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		padding: .63em .37em;
	}
`
TableV2Td.displayName = 'TableV2Td'

export const TableV2TdTitle = styled.div`
	font-size: 1em;
	font-family: ${theme.fontRobotoMedium};
	font-weight: 500;
	color: ${colorTheme.tableV2.color};

	&.desk-font-18 {
		font-size: 1.12em;
	}

	&.desk-font-20 {
		font-size: 1.25em;
	}

	&.desk-font-24 {
		font-size: 1.5em;
	}

	&.regular {
		font-family: ${theme.fontRobotoRegular};
		font-weight: 400;
	}

	&.bold {
		font-family: ${theme.fontRobotoBold};
		font-weight: 700;
	}

	&.red {
		color: ${colorTheme.tableV2.red};
	}

	&.green {
		color: ${colorTheme.tableV2.green};
	}

	&.gray {
		color: ${colorTheme.tableV2.gray};
	}

	@media screen and (max-width: ${theme.point820}) {
		font-size: 1.14em;

		&.tab-font-18 {
			font-size: 1.28em;
		}

		&.tab-font-20 {
			font-size: 1.43em;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		font-size: 1em;

		&.mob-font-18 {
			font-size: 1.12em;
		}

		&.mob-font-20 {
			font-size: 1.25em;
		}
	}
`
TableV2TdTitle.displayName = 'TableV2TdTitle'

export const TableV2MobileHeader = styled.div`
	display: none;

	@media screen and (max-width: ${theme.point820}) {
		min-height: 2.71em;
		width: 100%;
		display: grid;
		grid-column: 1/span 2;
		grid-template-columns: 1fr 1fr;
		background: ${colorTheme.tableV2.header.background};

		&:not(:first-child) {
			border-top: 1px solid ${colorTheme.tableV2.border};
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		min-height: 2.38em;
	}
`
TableV2MobileHeader.displayName = 'TableV2MobileHeader'

export const TableV2MobileHeaderTd = styled.div`
	@media screen and (max-width: ${theme.point820}) {
		width: 100%;
		padding: .63em .3em;
	}
`
TableV2MobileHeaderTd.displayName = 'TableV2MobileHeaderTd'

export const TableV2MobileHeaderTitle = styled.div`
	@media screen and (max-width: ${theme.point820}) {
		font-size: 1.07em;
		font-family: ${theme.fontRobotoMedium};
		color: ${colorTheme.tableV2.header.color};
	}

	@media screen and (max-width: ${theme.point720}) {
		font-size: 0.93em;
	}
`
TableV2MobileHeaderTitle.displayName = 'TableV2MobileHeaderTitle'

export const TableV2TdGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, auto);
	justify-content: start;
	align-items: center;
	gap: 0.35em;
	margin-top: 0.2em;

	> svg {
		width: 1.55em;
		height: 1.55em;
		fill: ${colorTheme.table.tableTd.icon};
	}

	@media screen and (max-width: ${theme.point720}) {
		column-gap: 0.5em;
		row-gap: 0;

		> svg {
			width: 1.65em;
			height: 1.65em;
			grid-column: 1;
		}
	}
`
TableV2TdGrid.displayName = 'TableV2TdGrid'

export const TableV2TdTitleStatus = styled(TableV2TdTitle)`
	${statusColorScheme};
`
TableV2TdTitleStatus.displayName = 'TableV2TdTitleStatus'
